/* eslint-disable camelcase */

import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */
export class FromLoanCalculationsToFinancingDataAggregateMapper extends Mapper {
  constructor({config, financingTermsRawDataToFinancingConditionEntityMapper}) {
    super()
    this._config = config
    this._culture = this._config.get('DEFAULT_CULTURE')
    this._financingTermsRawDataToFinancingConditionEntityMapper = financingTermsRawDataToFinancingConditionEntityMapper
    const {NO_INSURANCE} = config.get('financing').INSURANCE_IDS
    this._noInsuranceId = NO_INSURANCE
  }

  getFormattedDate = date => new Date(date).toLocaleDateString(this._culture)

  getParsedDateFirstInstallment = date =>
    this.isFormatedDate(date) ? date : new Date(date).toLocaleDateString(this._culture)

  getFinancingData = ({financingData, loanCalculationsObj}) => {
    return {
      availableTerm: financingData.availableTerm,
      availableTerms: loanCalculationsObj.availableTerms || [],
      cashPrice: financingData.cashPrice,
      capital: loanCalculationsObj.capital || financingData.capital,
      casualtyInsuranceAmount: financingData.casualtyInsuranceAmount || null,
      coefficient: financingData.coefficient || null,
      commissionEur: financingData.commissionEur || null,
      computedPrice: loanCalculationsObj.computedPrice || null,
      dateFirstInstallment:
        this.getParsedDateFirstInstallment(loanCalculationsObj.dateFirstInstallment) ||
        this.getParsedDateFirstInstallment(financingData.dateFirstInstallment),
      dateSignup:
        this.getFormattedDate(loanCalculationsObj.dateSignUp) || this.getFormattedDate(financingData.dateSignup),
      fareInsuranceId: loanCalculationsObj.fareInsuranceId || '',
      fee: loanCalculationsObj.fee || financingData.fee,
      financedPrice: financingData.financedPrice,
      firstFee: loanCalculationsObj.firstFee || financingData.firstFee,
      id: loanCalculationsObj.id || financingData.id,
      insuranceCoverages: loanCalculationsObj.insuranceCoverages || [],
      insuranceId: loanCalculationsObj.insuranceId || financingData.insuranceId,
      insuranceName: loanCalculationsObj.insuranceName || '',
      insuranceRate: loanCalculationsObj.insuranceRate || null,
      isOpeningExpensesFinanced: loanCalculationsObj.isOpeningExpensesFinanced || null,
      lender: loanCalculationsObj.lender || financingData.lender,
      lenderLegalTextId: financingData.lenderLegalTextId || '',
      lifeInsuranceAmount: loanCalculationsObj.lifeInsuranceAmount || financingData.lifeInsuranceAmount,
      loanRequestAvailable: financingData.loanRequestAvailable || null,
      maxEntry: loanCalculationsObj.maxEntry || financingData.maxEntry,
      maxEntryToGetDiscount: loanCalculationsObj.maxEntryToGetDiscount,
      minEntry: loanCalculationsObj.minEntry || financingData.minEntry,
      openingExpenses: loanCalculationsObj.openingExpenses || financingData.openingExpenses,
      openingPercentage: loanCalculationsObj.openingPercentage || financingData.openingPercentage,
      selectedOption: loanCalculationsObj.selectedOption,
      tae: loanCalculationsObj.tae || financingData.tae,
      terms: loanCalculationsObj.terms || financingData.terms,
      tin: loanCalculationsObj.tin || financingData.tin,
      totalAmountDue: loanCalculationsObj.totalAmountDue || financingData.totalAmountDue,
      totalInsuranceAmount: loanCalculationsObj.totalInsuranceAmount || financingData.totalInsuranceAmount,
      totalInterest: loanCalculationsObj.totalInterest || financingData.totalInterest,
      totalLoanAmount: loanCalculationsObj.totalLoanAmount || financingData.totalLoanAmount,
      totalLoanCost: loanCalculationsObj.totalLoanCost || financingData.totalLoanCost,
      totalPriceTerms: loanCalculationsObj.totalPriceTerms || financingData.totalPriceTerms,
      totalTermsAmount: loanCalculationsObj.totalTermsAmount || financingData.totalTermsAmount
    }
  }

  /**
   * @return {Object} financingTermsRawData
   */
  map = ({financingData, hasMultipleCalculations, loanCalculationsInfo}) => {
    const faresDataObj = loanCalculationsInfo.toJSON()
    const faresData = Object.values(faresDataObj)
    let tempObj = {}
    if (hasMultipleCalculations) {
      for (let i = 0; i < faresData.length; i++) {
        const loanCalculationsObj = faresData[i]
        const financingDataAggregateVO = this.getFinancingData({financingData, loanCalculationsObj})

        const objKey =
          financingDataAggregateVO.insuranceId === this._noInsuranceId ? 'withoutInsurance' : 'withInsurance'
        tempObj[objKey] = this._financingTermsRawDataToFinancingConditionEntityMapper.map({
          ...financingDataAggregateVO
        })
      }
    } else {
      const loanCalculationsObj = faresData.filter(loanCalc => loanCalc.insuranceId === financingData.insuranceId)
      const loanCalculationsInfoObj = loanCalculationsObj[0]

      tempObj = this.getFinancingData({financingData, loanCalculationsObj: loanCalculationsInfoObj})
    }

    return tempObj
  }
}
